module.exports = __webpack_public_path__ + "static/img/new14-Kd9Ls4Vw.1579224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new14-Kd9Ls4Vw.png
// module id = 69vM
// module chunks = 16